class ReferencesAPI {

  static all (state) {

    const { count, offset } = state
    let url = `/wp-json/wp/v2/references?per_page=${count}&offset=${offset}`

    return fetch(url, {
      credentials: 'same-origin',
    }).then(this.handleStatus)
  }

  static handleStatus (response) {
    if (!response.ok) {
      // Fetch doesn't reject on HTTP error status
      throw Error(`Request rejected with status ${response.status}`)
    }
    return response
  }

}

export default ReferencesAPI

// WEBPACK FOOTER //
// ./src/js/references/api/ReferencesAPI.js